import { render, staticRenderFns } from "./repairSettingList.vue?vue&type=template&id=18510326&scoped=true"
import script from "./repairSettingList.vue?vue&type=script&lang=js"
export * from "./repairSettingList.vue?vue&type=script&lang=js"
import style0 from "./repairSettingList.vue?vue&type=style&index=0&id=18510326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18510326",
  null
  
)

export default component.exports